import { apiSlice } from '../apiSlice';
import { API_DATA_MANAGER_URL } from '../../constants/env';
import { API_TAGS } from '../../constants/api';
import { MESSAGES } from './interactionMetadataMessages.js';

export const interactionsMetadataSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    fetchInteractionsMetadata: builder.query({
      query: ({ orgId, urlParams }) => ({
        url: `orgs/${orgId}/interactions`,
        method: 'GET',
        API_URL: API_DATA_MANAGER_URL,
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_INTERACTIONS_METADATA.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        return [{ type: API_TAGS.INTERACTIONS_METADATA, id: 'LIST' }];
      }
    }),

    fetchEventIdInteractionsMetadata: builder.query({
      query: ({ orgId, eventId, urlParams, errorMessage = { showMessage: false } }) => ({
        url: `orgs/${orgId}/events/${eventId}/interactions`,
        method: 'GET',
        API_URL: API_DATA_MANAGER_URL,
        params: {
          ...urlParams
        },
        errorMessage: {
          ...errorMessage,
          messages: MESSAGES.FETCH_EVENT_INTERACTIONS_METADATA.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        return [{ type: API_TAGS.INTERACTIONS_METADATA, id: args.eventId }];
      }
    }),

    fetchEventIdInteractionVariables: builder.query({
      query: ({ orgId, eventId, urlParams, errorMessage = { showMessage: false } }) => ({
        url: `orgs/${orgId}/events/${eventId}/session-variables`,
        method: 'GET',
        API_URL: API_DATA_MANAGER_URL,
        params: {
          ...urlParams
        },
        errorMessage: {
          ...errorMessage,
          messages: MESSAGES.FETCH_EVENT_INTERACTION_VARIABLES.ERROR
        }
      }),
      transformResponse: (response) => {

        const newData = response?.variables?.map((item) => {
          return {
            name: item?.key,
            value: item?.value
          };
        });
        return newData;
      },
      providesTags: (result, error, args) => {
        return [{ type: API_TAGS.INTERACTIONS_METADATA, id: args.eventId }];
      }
    })
  })
});

export const {
  useFetchInteractionsMetadataQuery,
  useLazyFetchInteractionsMetadataQuery,
  useFetchEventIdInteractionsMetadataQuery,
  useLazyFetchEventIdInteractionsMetadataQuery,
  useFetchEventIdInteractionVariablesQuery,
  useLazyFetchEventIdInteractionVariablesQuery
} = interactionsMetadataSlice;

